<template>
  <div class="cloudregion-setup-summary">
    <a-result
      v-if="cloudregion.setup.status === 'configured'"
      status="success"
      title="配置成功"
      class="ml-5"
      :sub-title="`您已完成${cloudregion.name || '当前可用区'}初始化配置`">
      <template #extra>
        <a-button @click="createVmPage" key="buy" :loading="createButtonClicked">
          创建虚拟机
        </a-button>
      </template>
    </a-result>
    <div v-else>
      <!--    // part 1: tips-->
      <div>
        <a-row>
          <h3 class="mt-2">{{ cloudregion.name || '' }}配置情况概览</h3>
        </a-row>
      </div>
      <a-alert
        v-if="tips"
        :message="cloudregion.setup.desc"
        class="mt-4"
        :type="tips.type"
        show-icon>
        <template #description>
          <div>{{ tips.desc }}</div>
          <div v-if="tips.solutions && tips.solutions.length > 0">
            <div>您可尝试如下解决方案,或联系平台技术支持</div>
            <ul>
              <li v-for="(v, index) of tips.solutions" :key="index">{{ v }}</li>
            </ul>
          </div>
        </template>
      </a-alert>
      <!--    // part 2: summary details-->
      <div class="mt-4">
        <a-row type="flex">
          <a-col flex="240px">
            <a-statistic title="VPC（可用/总数）" :value="cloudregion.related.vpcs.length">
              <template #suffix>
                <span> / {{ cloudregion.vpc_count || 0 }}</span>
              </template>
            </a-statistic>
          </a-col>
          <a-col flex="auto">
            <a-statistic title="子网（可用/总数）" :value="cloudregion.related.networks.length">
              <template #suffix>
                <span> / {{ cloudregion.network_count || 0 }}</span>
              </template>
            </a-statistic>
          </a-col>
        </a-row>
      </div>
      <div :style="{margin: '8px'}" v-if="cloudregion.related.vpcs">
        <a-row>
          <a-collapse default-active-key="1">
            <a-collapse-panel v-for="(rs, index) in cloudregion.related.vpcs" :key="index" :header="formatVpcName(rs)">
              <a-list :grid="{ gutter: 16, column: 3 }" :data-source="getVpcNetworks(rs)">
                <a-list-item slot="renderItem" slot-scope="item">
                  <div>
                    <span style="font-weight: bold;">{{ item.name }}</span>
                  </div>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_CLOUDACCOUNT_SETUP_TIPS } from '../../consts'

export default {
  name: 'RegionSetupSummary',
  props: {
    cloudaccount: {
      type: Object,
      required: true,
    },
    cloudregion: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      createButtonClicked: false,
    }
  },
  computed: {
    tips () {
      return GET_CLOUDACCOUNT_SETUP_TIPS(this.cloudregion.setup.status)
    },
    vpcNetworks () {
      const ret = {}
      this.cloudregion.related.networks.map(item => {
        if (ret[item.vpc_id]) {
          ret[item.vpc_id].push(item)
        } else {
          ret[item.vpc_id] = [item]
        }
      })
      return ret
    },
  },
  methods: {
    createVmPage () {
      this.createButtonClicked = true
      this.$router.push('/vminstance/create?type=public').then(() => {
        window.location.reload()
      })
    },
    getVpcNetworks (vpc) {
      return this.vpcNetworks[vpc.id] || []
    },
    formatVpcName (vpc) {
      let total = 0
      if (this.vpcNetworks.hasOwnProperty(vpc.id)) {
        total = this.vpcNetworks[vpc.id].length
      }
      return 'VPC:' + vpc.name + ` (子网数量: ${total})`
    },
    formatExternalId (ext) {
      if (!ext) return '-'
      const segs = ext.split('/')
      if (segs.length > 1) {
        return segs.slice(1).join('/')
      }
      return ext
    },
  },
}
</script>

<style scoped>
.cloudregion-setup-summary {
  position: absolute;
  width: inherit;
  padding-right: 12px;
}
</style>
